import { render } from "./documentoDetalle.vue?vue&type=template&id=9ed705ce"
import script from "./documentoDetalle.vue?vue&type=script&lang=js"
export * from "./documentoDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__